import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import {Provider} from "react-redux";
import * as Sentry from '@sentry/react'
import store from "@/store";
import '@/polyfill/history'
import '@/polyfill/appNotify'
import '@/polyfill/segmenter'
import pushyme from '@/services/Pushyme/Pushyme.ts';

export type AnyObject = Record<string, any>;

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_URL,
  sendDefaultPii: true
})

pushyme.init()

const root = ReactDOM.createRoot(
  document.getElementById('root')!
);
root.render(
  <Provider store={store}>
    <App/>
  </Provider>
);
